import { artistFetch } from './artist-api'
import { renderEpkDocument } from '@ovation/core'
import type { DraftRecord, EpkVariant } from './epk-draft-types'

export const listEpkDrafts = () => artistFetch<DraftRecord[]>('/epk-drafts')

export const getEpkDraft = (id: string) => artistFetch<DraftRecord>(`/epk-drafts/${id}`)

export const createEpkDraft = (body: {
  variant: EpkVariant
  label?: string
  seedFromDraftId?: string
}) => artistFetch<DraftRecord>('/epk-drafts', { method: 'POST', body })

export const updateEpkDraft = (
  id: string,
  body: { htmlBody?: string; cssBody?: string; label?: string },
) => artistFetch<DraftRecord>(`/epk-drafts/${id}`, { method: 'PATCH', body })

export const submitEpkDraft = (id: string) =>
  artistFetch<DraftRecord>(`/epk-drafts/${id}/submit`, { method: 'POST' })

export const authoriseEpkDraft = (id: string) =>
  artistFetch<DraftRecord>(`/epk-drafts/${id}/authorise`, { method: 'POST' })

export const archiveEpkDraft = (id: string) =>
  artistFetch<DraftRecord>(`/epk-drafts/${id}/archive`, { method: 'POST' })

/** Substitute sample tranche params into draft HTML for preview. */
export function previewDraftHtml(htmlBody: string, cssBody: string): string {
  return renderEpkDocument(htmlBody, cssBody, {
    periodLabel: 'May 2026',
    monthlyListeners: 1_240_000,
    spotifyFollowers: 890_000,
  }, {
    contactName: 'Jane Booker',
    eventType: 'festival',
    epkWebUrl: '#',
    epkDocxUrl: '#',
    instagramFollowers: '420,000',
    youtubeSubscribers: '310,000',
  })
}

export const presignEpkPdf = (id: string, filename: string, contentType = 'application/pdf') =>
  artistFetch<{ uploadUrl: string; pdfS3Key: string; pdfFilename: string }>(
    `/epk-drafts/${id}/pdf/presign`,
    { method: 'POST', body: { filename, contentType } },
  )

export const registerEpkPdf = (
  id: string,
  body: { pdfS3Key: string; pdfFilename: string },
) => artistFetch<DraftRecord>(`/epk-drafts/${id}/pdf`, { method: 'POST', body })
